import React, { useState } from 'react'
import AOS from "aos"; // Import AOS library
import CustomHelmet from '../components/CustomHelmet'
import Banner from '../components/Banner'
import PrivacyPolicySec from '../sections/privacypolicy/PrivacyPolicySec';
import { t } from 'i18next';
import * as constants from "../constants";
import { fetchAPI } from '../helper/fetchAPI';
import { useTranslation } from 'react-i18next';
import { useCountryPrefix } from '../routes/useCountryPrefix';
import FullScreenLoader from '../components/FullScreenLoader';

const PrivacyPolicy = () => {
    const { i18n } = useTranslation();
    const countryPrefix = useCountryPrefix();

    const isArabic = i18n.language === "ar";
    const language = isArabic ? "ar" : "en";
    const [isLoaded, setIsLoaded] = useState(false);
    const [pageContent, setPageContent] = useState();

    let apiUrl = process.env.REACT_APP_API_URL;

    apiUrl = `${apiUrl}${constants.staticpages}/privacy-policy?language=${language}&region_id=${countryPrefix}`;

    const fetchData = async () => {
        const res = await fetchAPI(apiUrl, "Get");
        if (res?.status === 200) {

            setPageContent(res?.data?.body)
            setIsLoaded(true)
        }
    }


    React.useEffect(() => {
        AOS.init();
        fetchData()
    }, []);

    if (!isLoaded) {
        return (
            <FullScreenLoader />
        )
    }
    return (
        <>
            <CustomHelmet
                title={"Exclusive Real Estate Across Egypt"}
                desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
            />
            <Banner
                title={t("privacypolicy")}
                desc={t("banner_desc")}
            ></Banner>
            <PrivacyPolicySec data={pageContent}></PrivacyPolicySec>
        </>
    )
}

export default PrivacyPolicy